
import React, { useContext, useEffect } from 'react';
import { withTranslation } from "react-i18next";
import { SidebarContext } from '../../../../App';
import './MaterialityAssessmentReport.scss';
import { FRONT_COVER_PAGE_NAME } from './materialityReportConfig';

const MaterialityAssessmentSidebar = ({
	sections,
	activeSectionIndex,
	onPageChange,
}) => {
	const { sidebarDisplay, setSidebarDisplay } = useContext(SidebarContext);

	useEffect(() => {
		setSidebarDisplay(false);
	}, []);

	useEffect(() => {
		return () => {
			setSidebarDisplay(true);
		};
	}, []);

	const renderSections = () =>
		sections?.map((section, sIndex) => (
			<li
				key={`mat-report-nav-${sIndex}`}
				className={section?.name === FRONT_COVER_PAGE_NAME ? 'MAReport_sidebar_title' : 'Reporting_SiderBar_Contents'}
			>
				<a
					className={activeSectionIndex === sIndex ? 'cursor active' : 'cursor'}
					title={section.name}
					onClick={() => onPageChange(sIndex, 0)}
				>
					<strong>{section.name}</strong>
				</a>
			</li>
		));

	return (
		<div className={`MaterialityAssessmentReport_sideBar ${sidebarDisplay ? '' : 'left-44'}`}>
			<ul className="MAReport_sidebar_ul">
				{renderSections()}
			</ul>
		</div>
	);
};

export default withTranslation()(MaterialityAssessmentSidebar);
